import ErrorResult from "./error-result";

export default ErrorResult;